const OVERVIEW_DETAIL_PARAM = "allcompletestubs";
const PARTIAL_REF_DETAIL_PARAM = "referencepartial";
const PARENTS_REF_PARAM = "parents";
const PARENTS_AND_SIBLINGS_REF_PARAM = "parentsandsiblings";
const CHILDREN_REF_PARAM = "children";
const ALL_REF_PARAM = "all";
const DIMOBS_PARAM_KEY = "dimensionAtObservation";
const START_PERIOD_PARAM_KEY = "startPeriod";
const END_PERIOD_PARAM_KEY = "endPeriod";
const LASTNOBS_PARAM_KEY = "lastNObservations";
const LAST_N_PERIODS_PARAM_KEY = "lastNPeriods";
const DIMOBS_PARAM = { key: DIMOBS_PARAM_KEY, value: "AllDimensions" };
export {
  ALL_REF_PARAM,
  CHILDREN_REF_PARAM,
  DIMOBS_PARAM,
  DIMOBS_PARAM_KEY,
  END_PERIOD_PARAM_KEY,
  LASTNOBS_PARAM_KEY,
  LAST_N_PERIODS_PARAM_KEY,
  OVERVIEW_DETAIL_PARAM,
  PARENTS_AND_SIBLINGS_REF_PARAM,
  PARENTS_REF_PARAM,
  PARTIAL_REF_DETAIL_PARAM,
  START_PERIOD_PARAM_KEY
};
